import { btn } from "../forms/FormControls.jsx";
import { downloadIcon } from "../icons/DownloadIcon.jsx";
export function exportButton(section) {
  return btn(
    <>
      <span aria-hidden="true" className="download-icon">
        {downloadIcon()}
      </span>{" "}
      Export CSV
    </>,
    `data-export="${section}"`,
    true,
  );
}
